interface ArticleHeroProps {
  kicker: string;
  title: string;
  standfirst?: string;
  author?: string;
  datePublished: string;
  dateModified?: string;
  readMinutes?: number;
}

function formatDate(iso: string) {
  const d = new Date(iso);
  return d.toLocaleDateString("en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export default function ArticleHero({
  kicker,
  title,
  standfirst,
  author = "Editorial team",
  datePublished,
  dateModified,
  readMinutes,
}: ArticleHeroProps) {
  return (
    <header className="container-prose pt-16 md:pt-24">
      <div className="eyebrow mb-6">{kicker}</div>
      <h1 className="font-serif text-display text-ink">{title}</h1>
      {standfirst && (
        <p className="mt-6 font-serif text-[1.35rem] leading-snug text-ink/80">
          {standfirst}
        </p>
      )}
      <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-1 text-small text-charcoal/70">
        <span>By {author}</span>
        <span>
          Published{" "}
          <time dateTime={datePublished}>{formatDate(datePublished)}</time>
        </span>
        {dateModified && dateModified !== datePublished && (
          <span>
            Last reviewed{" "}
            <time dateTime={dateModified}>{formatDate(dateModified)}</time>
          </span>
        )}
        {readMinutes && <span>{readMinutes} min read</span>}
      </div>
      <hr className="mt-10" />
    </header>
  );
}
